import { Component, OnInit } from '@angular/core';
import {ActivationUserRequest, ApiService, Software, SoftwaresList, Vps} from '../api/api.service';
import {LayoutManagerService} from '../layout-manager.service';
import {AuthService} from '../auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-admin-manager',
  templateUrl: './admin-manager.component.html',
  styleUrls: ['./admin-manager.component.css']
})
export class AdminManagerComponent implements OnInit {

  requests: ActivationUserRequest;
  softwares: SoftwaresList;
  changes = false;
  vpsList: Vps[];

  constructor(
    public layoutManager: LayoutManagerService,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private cookieService: CookieService
  ) { }

  ngOnInit() {
    this.requests = this.route.snapshot.data.requests;
    this.softwares = this.route.snapshot.data.admin_softwares;
    this.vpsList = this.route.snapshot.data.vps
  }

  acceptRequest(req) {
    if(!this.changes) {
      this.changes = true;
      this.api.acceptActivtionUsersRequests(req.email).subscribe(response => {
        this.changes = false;
        this.updateRequests()
      });
    }
  }

  acceptAdminSoftwareRequest(soft: Software) {
    if(!this.changes) {
      this.changes = true;
      soft.approved = true;
      this.api.updateSoftwareAdminIstance(soft).subscribe(response => {
        this.changes = false;
        this.updateRequests()
      });
    }
  }

  deleteRequest(req) {
    if(!this.changes) {
      this.changes = true;
      this.api.deleteActivtionRequests(req.email).subscribe(response => {
        this.changes = false;
        this.updateRequests()
      });
    }
  }

  updateRequests() {
    if(!this.changes) {
      this.changes = true;
      this.api.getActivtionUsersRequests().subscribe(response => {
        this.requests = response;
      });
      this.api.getSoftwaresList().subscribe(response => {
        this.softwares = response;
        this.changes = false
      })
    }
  }

  basetos(src: string): string {
    return atob(src)
  }

  changeVpsActivationState(email, state) {
    this.api.changeVpsActivationState(email,state).subscribe()
  }

  logout() {
    if (!this.changes) {
      this.cookieService.set( 'admin_email','');
      this.auth.doSignOutAdmin();
      this.router.navigateByUrl('/adminLogin');
    }
  }
}
